class VanillaHeaderFieldsToggle {
  constructor(selector = ".js-header-fields", options = {}) {
    this.selector = selector;

    this.activeClass = options.activeClass || "--is-active";
    this.breakpoint = options.breakpoint || 768;

    this.targets = Array.from(document.querySelectorAll(this.selector));

    if (!this.targets.length) return;

    this.mediaQuery = window.matchMedia(`(max-width: ${this.breakpoint}px)`);

    this.init();
  }

  init() {
    this.bindEvents();
    this.handleMediaChange();
  }

  bindEvents() {
    this.targets.forEach((target) => {
      target.addEventListener(
        "click",
        (event) => {
          this.handleClick(event, target);
        },
        false,
      );
    });

    this.mediaQuery.addEventListener(
      "change",
      () => {
        this.handleMediaChange();
      },
      false,
    );
  }

  handleClick(event, target) {
    if (!this.isMobile()) return;

    target.classList.toggle(this.activeClass);
  }

  handleMediaChange() {
    if (this.isMobile()) return;

    this.targets.forEach((target) => {
      target.classList.remove(this.activeClass);
    });
  }

  isMobile() {
    return this.mediaQuery.matches;
  }
}

export default VanillaHeaderFieldsToggle;
